// (function () {

//   console.log(
//     "Global Location JS Loaded"
//   );

//   /* ---------------------------
//      STORAGE CLEAR
//   ---------------------------- */
//   function clearLocationStorage() {

//     console.log(
//       "ZipGrow Frontend: Clearing session storage..."
//     );

//     sessionStorage.removeItem(
//       'selected_location'
//     );

//     sessionStorage.removeItem(
//       'selected_location_updated_at'
//     );
//   }

//   /* ---------------------------
//      INIT
//   ---------------------------- */
//   async function runLocationDetection() {

//     console.log(
//       "ZipGrow Frontend: Starting location detection..."
//     );

//     const existingSessionLocation =
//       sessionStorage.getItem(
//         'selected_location'
//       );

//     /* ---------------------------
//        USE STORED SESSION
//     ---------------------------- */
//     if (
//       existingSessionLocation
//     ) {

//       console.log(
//         "ZipGrow Frontend: API NOT called (cached session found)"
//       );

//       console.log(
//         "ZipGrow Frontend: Using cached location:",
//         existingSessionLocation
//       );

//       // APPLY IMMEDIATELY
//       updateLocationPricing(
//         existingSessionLocation
//       );

//       updateCartPrices(
//         existingSessionLocation
//       );

//       window.dispatchEvent(
//         new CustomEvent(
//           'locationUpdated',
//           {
//             detail:
//               existingSessionLocation
//           }
//         )
//       );

//       // Shopify rerender safety
//       setTimeout(() => {

//         updateLocationPricing(
//           existingSessionLocation
//         );

//         updateCartPrices(
//           existingSessionLocation
//         );

//       }, 500);

//       setTimeout(() => {

//         updateLocationPricing(
//           existingSessionLocation
//         );

//         updateCartPrices(
//           existingSessionLocation
//         );

//       }, 1500);

//       setTimeout(() => {

//         updateLocationPricing(
//           existingSessionLocation
//         );

//         updateCartPrices(
//           existingSessionLocation
//         );

//       }, 3000);

//       return;
//     }

//     /* ---------------------------
//        FIRST VISIT → API CALL
//     ---------------------------- */
//     console.log(
//       "ZipGrow Frontend: API CALLED (No cached session)"
//     );

//     const customerLocation =
//       await getCustomerLocation();

//     console.log(
//       "Final Customer Location:",
//       customerLocation
//     );

//     /* ---------------------------
//        SAVE SESSION
//     ---------------------------- */
//     if (
//       customerLocation
//     ) {

//       sessionStorage.setItem(
//         'selected_location',
//         customerLocation
//       );

//       sessionStorage.setItem(
//         'selected_location_updated_at',
//         Date.now()
//       );

//       console.log(
//         "ZipGrow Frontend: Session stored:",
//         customerLocation
//       );
//     }

//     window.dispatchEvent(
//       new CustomEvent(
//         'locationUpdated',
//         {
//           detail:
//             customerLocation
//         }
//       )
//     );

//     // Shopify rerenders price
//     setTimeout(() => {

//       updateLocationPricing(
//         customerLocation
//       );

//       updateCartPrices(
//         customerLocation
//       );

//     }, 500);

//     setTimeout(() => {

//       updateLocationPricing(
//         customerLocation
//       );

//       updateCartPrices(
//         customerLocation
//       );

//     }, 1500);

//     setTimeout(() => {

//       updateLocationPricing(
//         customerLocation
//       );

//       updateCartPrices(
//         customerLocation
//       );

//     }, 3000);
//   }

//   // Run immediately
//   runLocationDetection();

//   /* ---------------------------
//      PAGE CACHE RESTORE
//   ---------------------------- */
//   window.addEventListener(
//     'pageshow',
//     function(event) {

//       if (
//         event.persisted
//       ) {

//         console.log(
//           "ZipGrow Frontend: Page restored from browser cache"
//         );

//         runLocationDetection();
//       }
//     }
//   );

//   /* ---------------------------
//      TAB / BROWSER CLOSE
//   ---------------------------- */
//   // window.addEventListener(
//   //   'beforeunload',
//   //   clearLocationStorage
//   // );




//   /* ---------------------------
//      LOCATION DETECTION
//   ---------------------------- */
//   async function getCustomerLocation() {

//     // fallback
//     let location = null;

//     const saifaiPins = [
//       "206130",
//       "206131",
//       "206128",
//       "206126",
//       "206127",
//       "206124",
//       "364001"


//     ];

//     const palavaPins = [
//       "421201",
//       "421202",
//       "421203",
//       "421204",
//       "421301",

//     ];

//     try {

//       console.log(
//         "Getting browser location..."
//       );

//       const position =
//         await getCurrentPosition();

//         console.log('position',position);

//       const latitude =
//         position.coords
//           .latitude;

//       const longitude =
//         position.coords
//           .longitude;

//       console.log({
//         latitude,
//         longitude
//       });

//       const response =
//         await fetch(
//           `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
//           // `https://geocode.maps.co/reverse?lat=${latitude}&lon=${longitude}`
//         );

//       const data =
//         await response.json();

//       console.log(
//         "Location Data:",
//         data
//       );

//       const pincode =
//         String(
//           data?.address
//             ?.postcode ||
//           ""
//         ).trim();

//       console.log(
//         "Detected Pincode:",
//         pincode
//       );

//       /* -------------------------
//          LOCATION LOGIC
//       -------------------------- */
//       if (
//         saifaiPins.includes(
//           pincode
//         )
//       ) {

//         location =
//           "saifai";

//         console.log(
//           "Saifai location detected"
//         );

//       } else if (
//         palavaPins.includes(
//           pincode
//         )
//       ) {

//         location =
//           "palava";

//         console.log(
//           "Palava location detected"
//         );
//       }

//     } catch (err) {

//       console.log(
//         "Location detection failed → fallback used",
//         err
//       );
//     }

//     return location;
//   }


//   /* ---------------------------
//      GPS
//   ---------------------------- */
//   function getCurrentPosition() {

//     return new Promise(
//       (
//         resolve,
//         reject
//       ) => {

//         if (
//           !navigator.geolocation
//         ) {

//           reject(
//             new Error(
//               "Geolocation not supported"
//             )
//           );

//           return;
//         }

//         navigator.geolocation.getCurrentPosition(
//           resolve,
//           reject,
//           {
//             enableHighAccuracy: false, // MUCH FASTER: avoids triggering hardware GPS/extensive scans
//             timeout: 5000,             // Shorter timeout to fail fast if stuck
//             maximumAge: 600000         // Use cached position (up to 10 minutes) instantly
//           }
//         );
//       }
//     );
//   }


//   /* ---------------------------
//      MONEY FORMAT
//   ---------------------------- */
//   function formatMoney(
//     price,
//     isShopifyPrice = false
//   ) {

//     let num =
//       parseFloat(price);

//     if (
//       isNaN(num)
//     ) {

//       return "Rs. 0.00";
//     }

//     /* --------------------------------
//        Shopify default price fix
//        63000 -> 630.00
//     --------------------------------- */
//     if (
//       isShopifyPrice
//     ) {

//       num =
//         num / 100;
//     }

//     return `Rs. ${num.toFixed(2)}`;
//   }


//   /* ---------------------------
//      PRODUCT / COLLECTION PRICE
//   ---------------------------- */
//   function updateLocationPricing(
//     location
//   ) {

//     console.log(
//       "Function Called"
//     );

//     const allPriceBlocks =
//       document.querySelectorAll(
//         ".price"
//       );

//     allPriceBlocks.forEach(
//       (priceBlock) => {

//         const pricingData =
//           priceBlock.querySelector(
//             ".location-pricing-data"
//           );

//         if (!pricingData) return;

//         /* -------------------------
//            DATA
//         -------------------------- */

//         const saifaiPrice =
//           pricingData.dataset.saifaiPrice;

//         const saifaiCompare =
//           pricingData.dataset.saifaiCompare;

//         const palavaPrice =
//           pricingData.dataset.palavaPrice;

//         const palavaCompare =
//           pricingData.dataset.palavaCompare;

//         const saifaiAllowed =
//           parseBool(
//             pricingData.dataset.saifaiLocation
//           );

//         const palavaAllowed =
//           parseBool(
//             pricingData.dataset.palavaLocation
//           );

//         let finalPrice = null;
//         let finalCompare = null;
//         let allowed = false;

//         /* -------------------------
//            LOCATION LOGIC
//         -------------------------- */

//         if (
//           location === "saifai"
//         ) {

//           finalPrice =
//             saifaiPrice;

//           finalCompare =
//             saifaiCompare;

//           allowed =
//             saifaiAllowed;

//         } else {

//           finalPrice =
//             palavaPrice;

//           finalCompare =
//             palavaCompare;

//           allowed =
//             palavaAllowed;
//         }

//         const regularPrice =
//           priceBlock.querySelector(
//             ".custom-location-price"
//           );

//         const salePrice =
//           priceBlock.querySelector(
//             ".custom-location-sale-price"
//           );

//         const comparePrice =
//           priceBlock.querySelector(
//             ".price__sale s"
//           );

//         /* -------------------------
//            NOT AVAILABLE
//         -------------------------- */

//         // if (
//         //   !allowed ||
//         //   !finalPrice
//         // ) {

//         //   if (regularPrice) {

//         //     regularPrice.innerHTML =
//         //       "Not Available";
//         //   }

//         //   if (salePrice) {

//         //     salePrice.innerHTML =
//         //       "Not Available";
//         //   }

//         //   return;
//         // }

//         const isPalava =
//           location === "palava";

//         const formattedPrice =
//           formatMoney(
//             finalPrice,
//             isPalava
//           );

//         const formattedCompare =
//           finalCompare
//             ? formatMoney(
//                 finalCompare,
//                 isPalava
//               )
//             : null;

//         /* -------------------------
//            UPDATE PRICE
//         -------------------------- */

//         if (regularPrice) {

//           regularPrice.innerHTML =
//             formattedPrice;
//         }

//         if (salePrice) {

//           salePrice.innerHTML =
//             formattedPrice;
//         }

//         /* -------------------------
//            UPDATE COMPARE PRICE
//         -------------------------- */

//         if (
//           comparePrice &&
//           formattedCompare
//         ) {

//           comparePrice.innerHTML =
//             formattedCompare;
//         }

//       }
//     );
//   }


//   function updateCartPrices(
//   location
// ) {

//   console.log(
//     "Cart Price Function Called"
//   );

//   const cartItems =
//     document.querySelectorAll(
//       ".cart-item"
//     );

//   if (!cartItems.length) {
//     return;
//   }

//   let subtotal = 0;

//   cartItems.forEach((cartItem) => {

//     const pricingData =
//       cartItem.querySelector(
//         ".cart-location-pricing"
//       );

//     if (!pricingData) {
//       return;
//     }

//     /* -------------------------
//        DATA
//     -------------------------- */
//     const saifaiPrice =
//       parseFloat(
//         pricingData.dataset
//           .saifaiPrice
//       ) || 0;

//     const palavaPrice =
//       parseFloat(
//         pricingData.dataset
//           .palavaPrice
//       ) || 0;

//     const saifaiAllowed =
//       parseBool(
//         pricingData.dataset
//           .saifaiLocation
//       );

//     const palavaAllowed =
//       parseBool(
//         pricingData.dataset
//           .palavaLocation
//       );

//     let finalPrice =
//       0;

//     let allowed =
//       false;

//     /* -------------------------
//        LOCATION
//     -------------------------- */
//     if (
//       location ===
//       "saifai"
//     ) {

//       finalPrice =
//         saifaiPrice;

//       allowed =
//         saifaiAllowed;

//     } else {

//       // finalPrice =
//       //   palavaPrice;
//       finalPrice =
//   palavaPrice / 100;

//       allowed =
//         palavaAllowed;
//     }

//     /* -------------------------
//        LIVE QUANTITY
//     -------------------------- */
//     const quantityInput =
//       cartItem.querySelector(
//         ".quantity__input"
//       );

//     const quantity =
//       parseInt(
//         quantityInput
//           ?.value || 1
//       );

//     /* -------------------------
//        ELEMENTS
//     -------------------------- */
//     const regularPrice =
//       cartItem.querySelector(
//         ".custom-cart-price"
//       );

//     const salePrice =
//       cartItem.querySelector(
//         ".custom-cart-final-price"
//       );

//     const lineTotals =
//       cartItem.querySelectorAll(
//         ".custom-cart-line-total"
//       );

//     /* -------------------------
//        NOT AVAILABLE
//     -------------------------- */
//     if (
//       !allowed ||
//       !finalPrice
//     ) {

//       if (regularPrice) {
//         regularPrice.innerHTML =
//           "Not Available";
//       }

//       if (salePrice) {
//         salePrice.innerHTML =
//           "Not Available";
//       }

//       return;
//     }

//     const formattedPrice =
//       formatMoney(
//         finalPrice
//       );

//     const totalPrice =
//       parseFloat(
//         finalPrice
//       ) * quantity;

//     subtotal +=
//       totalPrice;

//     const formattedTotal =
//       formatMoney(
//         totalPrice
//       );

//     /* -------------------------
//        UPDATE PRICE
//     -------------------------- */
//     if (
//       regularPrice
//     ) {

//       regularPrice.innerHTML =
//         formattedPrice;
//     }

//     if (
//       salePrice
//     ) {

//       salePrice.innerHTML =
//         formattedPrice;
//     }

//     if (
//       lineTotals.length
//     ) {

//       lineTotals.forEach(
//         (el) => {

//           el.innerHTML =
//             formattedTotal;
//         }
//       );
//     }
//   });

//   /* -------------------------
//      UPDATE SUBTOTAL
//   -------------------------- */
//   const subtotalElement =
// document.querySelector(
//   ".totals__total-value, .totals__subtotal-value, .totals__subtotal"
// );

//   if (
//     subtotalElement
//   ) {

//     subtotalElement.innerHTML =
//       formatMoney(
//         subtotal
//       );
//   }

//   console.log(
//     "💰 Cart subtotal updated:",
//     subtotal
//   );
// }


// /* -------------------------
//    CART AJAX OBSERVER FIX
// -------------------------- */
// const cartObserver =
//   new MutationObserver(
//     () => {

//       const location =
//         sessionStorage.getItem(
//           "selected_location"
//         );

//       console.log(
//         "🛒 Cart DOM Updated"
//       );

//       setTimeout(() => {

//         updateCartPrices(
//           location
//         );

//       }, 200);

//       setTimeout(() => {

//         updateCartPrices(
//           location
//         );

//       }, 700);

//     }
//   );

// const cartContainer =
//   document.querySelector(
//     "cart-items, .cart-items, #main-cart-items"
//   );

// if (
//   cartContainer
// ) {

//   cartObserver.observe(
//     cartContainer,
//     {
//       childList: true,
//       subtree: true
//     }
//   );
// }


// /* -------------------------
//    CART QUANTITY CLICK FIX
// -------------------------- */
// document.addEventListener(
//   "click",
//   function (e) {

//     const qtyButton =
//       e.target.closest(
//         ".quantity__button"
//       );

//     if (!qtyButton) {
//       return;
//     }

//     console.log(
//       "🔄 Quantity Button Clicked"
//     );

//     const location =
//       sessionStorage.getItem(
//         "selected_location"
//       );

//     // Wait for Shopify AJAX
//     setTimeout(() => {

//       updateCartPrices(
//         location
//       );

//     }, 500);

//     setTimeout(() => {

//       updateCartPrices(
//         location
//       );

//     }, 1200);

//     setTimeout(() => {

//       updateCartPrices(
//         location
//       );

//     }, 2200);
//   }
// );


//   /* ---------------------------
//      BOOLEAN
//   ---------------------------- */
//   function parseBool(
//     val
//   ) {

//     return [
//       true,
//       "true",
//       "True",
//       "TRUE",
//       "1",
//       1
//     ].includes(val);
//   }

// })();






(function () {

  /* ---------------------------
     INIT
  ---------------------------- */

  async function runLocationDetection() {

    const savedLocation =
      localStorage.getItem(
        "selected_location"
      );

    if (!savedLocation) {

      console.log(
        "No location selected"
      );

      return;
    }

    updateLocationPricing(
      savedLocation
    );

    updateCartPrices(
      savedLocation
    );

    window.dispatchEvent(
      new CustomEvent(
        "locationUpdated",
        {
          detail:
            savedLocation
        }
      )
    );

    setTimeout(() => {

      updateLocationPricing(
        savedLocation
      );

      updateCartPrices(
        savedLocation
      );

    }, 500);

    setTimeout(() => {

      updateLocationPricing(
        savedLocation
      );

      updateCartPrices(
        savedLocation
      );

    }, 1500);

    setTimeout(() => {

      updateLocationPricing(
        savedLocation
      );

      updateCartPrices(
        savedLocation
      );

    }, 3000);
  }

  runLocationDetection();

  document.addEventListener(
  "DOMContentLoaded",
  function () {

    const location =
      localStorage.getItem(
        "selected_location"
      );

    if (!location) {
      return;
    }

    updateCartPrices(
      location
    );

  }
);

  /* ---------------------------
     PAGE CACHE RESTORE
  ---------------------------- */

  window.addEventListener(
    "pageshow",
    function(event) {

      if (
        event.persisted
      ) {

        runLocationDetection();
      }
    }
  );

  /* ---------------------------
     MONEY FORMAT
  ---------------------------- */

  function formatMoney(
    price,
    isShopifyPrice = false
  ) {

    let num =
      parseFloat(price);

    if (
      isNaN(num)
    ) {

      return "Rs. 0.00";
    }

    if (
      isShopifyPrice
    ) {

      num =
        num / 100;
    }

    return `Rs. ${num.toFixed(2)}`;
  }

  /* ---------------------------
     PRODUCT PRICE
  ---------------------------- */

  // function updateLocationPricing(
  //   location
  // ) {
  window.updateLocationPricing =
function(
  location
) {

    const allPriceBlocks =
      document.querySelectorAll(
        ".price"
      );

    allPriceBlocks.forEach(
      (priceBlock) => {

        const pricingData =
          priceBlock.querySelector(
            ".location-pricing-data"
          );

        if (!pricingData) {
          return;
        }

        const saifaiPrice =
          pricingData.dataset.saifaiPrice;

        const saifaiCompare =
          pricingData.dataset.saifaiCompare;

        const palavaPrice =
          pricingData.dataset.palavaPrice;

        const palavaCompare =
          pricingData.dataset.palavaCompare;

          const karhalPrice =
    pricingData.dataset.karhalPrice;

const karhalCompare =
    pricingData.dataset.karhalCompare;

        const saifaiAllowed =
          parseBool(
            pricingData.dataset.saifaiLocation
          );

        const palavaAllowed =
          parseBool(
            pricingData.dataset.palavaLocation
          );

          const karhalAllowed =
        parseBool(
          pricingData.dataset.karhalLocation
        );

        let finalPrice = null;
        let finalCompare = null;
        let allowed = false;

        if (
          location === "saifai"
        ) {

          finalPrice =
            saifaiPrice;

          finalCompare =
            saifaiCompare;

          allowed =
            saifaiAllowed;

        }else if (
        location === "karhal"
      ) {

        /*
         * Karhal
         * Default Shopify product price
         * Same as Saifai
         */

        finalPrice =
          karhalPrice;

        finalCompare =
          karhalCompare;

        allowed =
          karhalAllowed;

      }
        else {

          finalPrice =
            palavaPrice;

          finalCompare =
            palavaCompare;

          allowed =
            palavaAllowed;
        }

        const regularPrice =
          priceBlock.querySelector(
            ".custom-location-price"
          );

        const salePrice =
          priceBlock.querySelector(
            ".custom-location-sale-price"
          );

        const comparePrice =
          priceBlock.querySelector(
            ".price__sale s"
          );

        // const isPalava =
        //   location === "palava";

        const isPalava =
          location === "kanpur";

          const isShopifyPrice =
  finalPrice >= 1000;

const formattedPrice =
  formatMoney(
    finalPrice,
    isShopifyPrice
  );

const formattedCompare =
  finalCompare
    ? formatMoney(
        finalCompare,
        isShopifyPrice
      )
    : null;

        // const formattedPrice =
        //   formatMoney(
        //     finalPrice,
        //     isPalava
        //   );

        // const formattedCompare =
        //   finalCompare
        //     ? formatMoney(
        //         finalCompare,
        //         isPalava
        //       )
        //     : null;

        if (regularPrice) {
          regularPrice.innerHTML =
            formattedPrice;
        }

        if (salePrice) {
          salePrice.innerHTML =
            formattedPrice;
        }

        if (
          comparePrice &&
          formattedCompare
        ) {

          comparePrice.innerHTML =
            formattedCompare;
        }

      }
    );
  }

  /* ---------------------------
     CART PRICE
  ---------------------------- */

  function updateCartPrices(
    location
  ) {

    const cartItems =
      document.querySelectorAll(
        ".cart-item"
      );

    if (!cartItems.length) {
      return;
    }

    let subtotal = 0;

    const subtotalIsShopifyPrice =
    location === "saifai"||
    location === "karhal";

    cartItems.forEach(
      (cartItem) => {

        const pricingData =
          cartItem.querySelector(
            ".cart-location-pricing"
          );

        if (!pricingData) {
          return;
        }

        const saifaiPrice =
          parseFloat(
            pricingData.dataset
              .saifaiPrice
          ) || 0;

        const palavaPrice =
          parseFloat(
            pricingData.dataset
              .palavaPrice
          ) || 0;

        const karhalPrice =
        parseFloat(
          pricingData.dataset
            .karhalPrice
        ) || 0;

        let finalPrice = 0;

        // if (
        //   location === "saifai"
        // ) {

        //   finalPrice =
        //     saifaiPrice;

        // } else {

        //   finalPrice =
        //     palavaPrice / 100;
        // }
        let isShopifyPrice = false;

if (location === "saifai") {

    finalPrice = saifaiPrice;
    isShopifyPrice = true;

}else if (
        location === "karhal"
      ) {

        /*
         * Karhal
         * Same default Shopify price as Saifai.
         */

        finalPrice =
          karhalPrice;

        isShopifyPrice =
          true;

      }
 else {

    finalPrice = palavaPrice;
    isShopifyPrice = false;

}

        const quantityInput =
          cartItem.querySelector(
            ".quantity__input"
          );

        const quantity =
          parseInt(
            quantityInput?.value || 1
          );

        const regularPrice =
          cartItem.querySelector(
            ".custom-cart-price"
          );

        const salePrice =
          cartItem.querySelector(
            ".custom-cart-final-price"
          );

        const lineTotals =
          cartItem.querySelectorAll(
            ".custom-cart-line-total"
          );

        // const formattedPrice =
        //   formatMoney(
        //     finalPrice
        //   );
        const formattedPrice =
  formatMoney(
    finalPrice,
    isShopifyPrice
  );

        const totalPrice =
          parseFloat(
            finalPrice
          ) * quantity;

        subtotal += totalPrice;

        // const formattedTotal =
        //   formatMoney(
        //     totalPrice
        //   );
        const formattedTotal =
  formatMoney(
    totalPrice,
    isShopifyPrice
  );

        if (regularPrice) {
          regularPrice.innerHTML =
            formattedPrice;
        }

        if (salePrice) {
          salePrice.innerHTML =
            formattedPrice;
        }

        if (
          lineTotals.length
        ) {

          lineTotals.forEach(
            (el) => {

              el.innerHTML =
                formattedTotal;
            }
          );
        }
      }
    );

    const subtotalElement =
      document.querySelector(
        ".totals__total-value, .totals__subtotal-value, .totals__subtotal"
      );

    if (
      subtotalElement
    ) {

      // subtotalElement.innerHTML =
      //   formatMoney(
      //     subtotal
      //   );
      subtotalElement.innerHTML =
  formatMoney(
    subtotal,
    subtotalIsShopifyPrice
  );
    }
  }

  /* ---------------------------
     CART OBSERVER
  ---------------------------- */

  const cartObserver =
    new MutationObserver(
      () => {

        const location =
          localStorage.getItem(
            "selected_location"
          );

        setTimeout(() => {

          updateCartPrices(
            location
          );

        }, 300);
      }
    );

  const cartContainer =
    document.querySelector(
      "cart-items, .cart-items, #main-cart-items"
    );

  if (
    cartContainer
  ) {

    cartObserver.observe(
      cartContainer,
      {
        childList: true,
        subtree: true
      }
    );
  }

  /* ---------------------------
     BOOLEAN
  ---------------------------- */

  function parseBool(
    val
  ) {

    return [
      true,
      "true",
      "True",
      "TRUE",
      "1",
      1
    ].includes(val);
  }

})();